<template>
  <div class="adx-container">
    <!-- PGY 来源广告 -->
    <div class="adx">
      <pgy-static-sdk
        v-show="showPGY"
        :env="pgyEnv"
        :ad-data="adData"
        :mcc-config="mccConfig"
        mcc-key="STATIC_12237_12239"
        @fail_load="failLoad"
        @success_load="successLoad"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { PgyStaticSdk } from '@fdfe/marketing-sdk';
import { monitor, env, Runtime, ResultAdxMetricPoints } from '@/common';

export default Vue.extend({
  name: 'Adx',

  components: {
    PgyStaticSdk,
  },

  props: {
    adxData: {
      default: () => ({} as PayDeferAdxType),
      type: Object as () => PayDeferAdxType,
    },
  },

  data() {
    return {
      showPGY: false,
      pgyEnv: Runtime[env.runtime].toLocaleLowerCase(),
    };
  },

  computed: {
    adData(): any {
      return this.adxData?.spaceAdxDTO?.spaceHitAds || [];
    },

    // pgy mcc config
    mccConfig(): any {
      try {
        return JSON.parse(this.adxData.more.lionConfig);
      } catch (error) {
        return {};
      }
    },
  },

  methods: {
    // pgy 解析结果失败回调
    failLoad(val?: any) {
      monitor.captureMessage({
        name: '[payDelayAdx error] PGY组件内部异常',
        msg: val.message || 'PGY组件内部返回异常',
      });

      monitor.reportMetric(ResultAdxMetricPoints.AdxError, {
        system: env.system,
        isOffline: env.resultLxCommonParams.isOffline,
        businessType: env.resultLxCommonParams.businessType,
        adSystem: 'paydefer_ad',
      });
    },

    // pgy 解析结果成功回调
    successLoad(val: any) {
      this.showPGY = true;
      monitor.reportMetric(ResultAdxMetricPoints.AdxShow, {
        system: env.system,
        isOffline: env.resultLxCommonParams.isOffline,
        businessType: env.resultLxCommonParams.businessType,
        adSystem: 'paydefer_ad',
      });
    },
  },
});
</script>

<style lang="less" scoped>
.adx-container {
  position: relative;
  background: #f7f7f7;
  border-radius: 0.12rem;
  margin-top: 0.18rem;

  .adx {
    > div,
    > img {
      display: block;
      width: 100%;
      border-radius: 0.12rem;
      overflow: hidden;
    }
  }
}
</style>
